module.exports = __webpack_public_path__ + "static/media/instagram-small-icon-12.3e60846d.jpg";